var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoopArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Button-Loop-Arrow--Streamline-Ultimate.svg",
    clipPath: "url(#clip0_30472_1081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.2284 26.566C24.8196 28.7069 27.2646 30.048 29.9251 30.2394C36.5261 30.2394 40.6518 23.0935 37.3513 17.3769C35.8194 14.7239 32.9886 13.0894 29.9251 13.0894C23.8001 13.0894 20.1251 21.6644 20.1251 21.6644C20.1251 21.6644 16.4501 30.2394 10.3251 30.2394C3.72408 30.2394 -0.401583 23.0935 2.89892 17.3769C4.43075 14.7239 7.26158 13.0894 10.3251 13.0894C13.1963 13.3542 15.8426 14.7555 17.6751 16.9817",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.6688 10.9399L17.675 16.9816L11.6333 17.9893",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30472_1081"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.125 0.5896)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoopArrow);
export default __webpack_public_path__ + "static/media/loop-arrow.f1d732b69865c2dbf376f6c9abbd68c5.svg";
export { ForwardRef as ReactComponent };